var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12946",
    "data-name": "Group 12946",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 10,
    viewBox: "0 0 30 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2509",
    "data-name": "Rectangle 2509",
    width: 30,
    height: 10,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12946-2",
    "data-name": "Group 12946",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12950",
    "data-name": "Path 12950",
    d: "M137.294,10a1.661,1.661,0,0,1-.655-.136l-4.84-2.11a1.578,1.578,0,0,1-.848-.877,1.523,1.523,0,0,1,.032-1.207L133.142.935a1.63,1.63,0,0,1,2.13-.8l4.84,2.11a1.567,1.567,0,0,1,.816,2.084L138.77,9.065a1.583,1.583,0,0,1-.9.829,1.71,1.71,0,0,1-.58.1M134.617.862a.737.737,0,0,0-.671.425l-2.157,4.734a.713.713,0,0,0,.37.95L137,9.081a.747.747,0,0,0,.563.016.732.732,0,0,0,.408-.378l2.157-4.734a.713.713,0,0,0-.37-.95l-4.84-2.11a.7.7,0,0,0-.3-.063",
    transform: "translate(-123.823 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12951",
    "data-name": "Path 12951",
    d: "M407.152,39.938h-5.3a1.6,1.6,0,0,1-1.615-1.58v-5.18a1.6,1.6,0,0,1,1.615-1.58h5.3a1.6,1.6,0,0,1,1.615,1.58v5.18a1.6,1.6,0,0,1-1.615,1.58m-5.3-7.479a.728.728,0,0,0-.735.719v5.18a.728.728,0,0,0,.735.719h5.3a.728.728,0,0,0,.735-.719v-5.18a.728.728,0,0,0-.735-.719Z",
    transform: "translate(-378.767 -29.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12952",
    "data-name": "Path 12952",
    d: "M8.774,20.445,8.12,21.88l.3,1.794a.721.721,0,0,1-.606.824l-5.231.829a.751.751,0,0,1-.547-.126.7.7,0,0,1-.3-.467L.89,19.622A.721.721,0,0,1,1.5,18.8l5.231-.829a.9.9,0,0,1,.118-.01.731.731,0,0,1,.429.136.7.7,0,0,1,.3.467l.293,1.77L8.517,18.9l-.078-.471A1.576,1.576,0,0,0,7.79,17.4a1.628,1.628,0,0,0-1.2-.278l-5.231.829A1.584,1.584,0,0,0,.021,19.759l.848,5.112A1.576,1.576,0,0,0,1.518,25.9a1.621,1.621,0,0,0,.939.3,2.308,2.308,0,0,0,.268-.021l5.226-.829a1.584,1.584,0,0,0,1.336-1.811Z",
    transform: "translate(0 -16.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12953",
    "data-name": "Path 12953",
    d: "M272.849,24.878l.683-1.5-.249-1.794a.7.7,0,0,1,.145-.53.734.734,0,0,1,.483-.278l5.247-.7a.6.6,0,0,1,.1-.005.746.746,0,0,1,.52.213,1.624,1.624,0,0,1,.81-.393,1.629,1.629,0,0,0-1.545-.665l-5.247.7a1.615,1.615,0,0,0-1.068.609,1.535,1.535,0,0,0-.317,1.17Z",
    transform: "translate(-257.778 -18.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12954",
    "data-name": "Path 12954",
    d: "M293.6,53.083,292.9,48.1h-.012a.728.728,0,0,0-.735.719v.311l.565,4.067a.7.7,0,0,1-.145.53.733.733,0,0,1-.483.278l-5.247.7a.73.73,0,0,1-.826-.614l-.239-1.719-.683,1.5.047.339a1.613,1.613,0,0,0,1.819,1.349l5.247-.693a1.593,1.593,0,0,0,1.384-1.779",
    transform: "translate(-269.801 -45.573)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/Zoho.630a18b26a9b474c2e17863289ef8e85.svg";
export { ForwardRef as ReactComponent };